/*
 *
 * Activity reducer
 *
 */

export const Types = {
  // Obtem aulas de um curso
  GET_LIST_REQUEST: 'activity-by-module/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'activity-by-module/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'activity-by-module/GET_LIST_FAILURE',
};

export const initialState = {
  // Lista de aulas de um curso
  activityList: [],
  activityListLoading: false,
  activityListError: null,
  activityListTotal: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Lista de aulas de um curso
    case Types.GET_LIST_REQUEST:
      return { ...state, activityListLoading: true };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        activityList: action.payload.data,
        activityListLoading: false,
        activityListError: null,
        activityListTotal: action.payload.total,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        activityListLoading: false,
        activityListError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Busca lista de aulas de um curso
  getActivityListRequest: data =>({
    type: Types.GET_LIST_REQUEST,
    payload: data,
  }),
  getActivityListSuccess: ({ data, total }) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { data, total },
  }),
  getActivityListFailure: error => ({
    type: Types.GET_LIST_FAILURE,
    payload: error,
  }),
};
